export default __webpack_public_path__ + "static/media/3.61036de4.jpg";